module.exports = __webpack_public_path__ + "static/picture_ecommerce.7b6ca04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexFirstView/assets/img/picture_ecommerce.png
// module id = 560
// module chunks = 213534597649335